import React from "react";
import { Input } from "@/components/ui/input";
import { Lock, Info } from "lucide-react";
import { formatDOP } from "@/lib/format";

const ISR_TYPES = { "01": "01 · Alquileres", "02": "02 · Honorarios / servicios", "03": "03 · Otras rentas", "07": "07 · Proveedores del Estado" };

// Resumen de la compra con retenciones ITBIS/ISR sugeridas por ley (editables salvo ITBIS en E41).
export function PurchaseRetentions({ totals, sug, ret, setRet }) {
  const net = totals.total - Number(ret.itbis_retenido || 0) - Number(ret.isr_retenido || 0);
  const noIsr = !sug || sug.isr_base <= 0;
  return (
    <div className="rounded-md bg-muted/40 p-3 space-y-3" data-testid="purchase-summary">
      <div className="grid grid-cols-2 md:grid-cols-6 gap-3 text-sm">
        <Cell label="Subtotal" value={formatDOP(totals.subtotal)} testid="purchase-subtotal" />
        <Cell label="ITBIS" value={formatDOP(totals.itbis)} testid="purchase-itbis" />
        <div>
          <div className="overline flex items-center gap-1">Ret. ITBIS {sug?.itbis_locked && <Lock className="w-3 h-3" />}</div>
          <Input type="number" step="0.01" className="h-8 font-mono" value={ret.itbis_retenido} disabled={sug?.itbis_locked}
            onChange={(e) => setRet({ ...ret, itbis_retenido: e.target.value })} data-testid="purchase-itbis-ret" />
        </div>
        <div>
          <div className="overline">Ret. ISR {sug && !noIsr && <span className="normal-case">({Math.round(sug.isr_rate * 100)}%)</span>}</div>
          <Input type="number" step="0.01" className="h-8 font-mono" value={ret.isr_retenido} disabled={noIsr}
            onChange={(e) => setRet({ ...ret, isr_retenido: e.target.value })} data-testid="purchase-isr-ret" />
        </div>
        <div>
          <div className="overline">Tipo ISR (606)</div>
          <select className="h-8 w-full rounded-md border border-input bg-transparent px-2 text-xs" value={ret.isr_retention_type}
            disabled={Number(ret.isr_retenido || 0) <= 0} onChange={(e) => setRet({ ...ret, isr_retention_type: e.target.value })} data-testid="purchase-isr-type">
            <option value="">—</option>
            {Object.entries(ISR_TYPES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </div>
        <Cell label="Neto a pagar" value={formatDOP(net)} testid="purchase-net" strong />
      </div>
      <ul className="text-[11px] text-muted-foreground space-y-0.5" data-testid="purchase-ret-notes">
        {noIsr && <li className="flex gap-1"><Info className="w-3 h-3 mt-0.5 shrink-0" />Bienes: no llevan retención de ISR.</li>}
        {(sug?.notes || []).map((n) => <li key={n} className="flex gap-1"><Info className="w-3 h-3 mt-0.5 shrink-0" />{n}</li>)}
        <li className="flex gap-1"><Info className="w-3 h-3 mt-0.5 shrink-0" />Sugerido por Amelia según la ley vigente; estos montos van al 606 y el ISR se paga en el IR-17.</li>
      </ul>
    </div>
  );
}

function Cell({ label, value, testid, strong }) {
  return (
    <div>
      <div className="overline">{label}</div>
      <div className={`font-mono font-bold ${strong ? "text-primary" : ""}`} data-testid={testid}>{value}</div>
    </div>
  );
}
